import { LOCAL_STORE_KEY_CONFIGURATION, hasKey, removeLocalStorageCache, setLocalStorageCache, getLocalStorageCache } from '@/utils/storageDataCache'

class LocalStorageUtils {
  /*
   * The configuration is saved as local shared object. So the value should
   * serializable to local storage.
   */
  static setConfiguration(key, value) {
    if (typeof value !== 'string') {
      value = JSON.stringify(value)
    }
    // window.localStorage.setItem(key, value)
    setLocalStorageCache(LOCAL_STORE_KEY_CONFIGURATION + key, value, true)
  }
  static hasConfiguration(key) {
    return hasKey(LOCAL_STORE_KEY_CONFIGURATION + key, true)
  }

  /*
    * The configuration is saved as local shared object. So the value should
    * serializable to local storage.
    */
  static getConfiguration(key, dataType = 'json') {
    // let returnData = window.localStorage.getItem(key)
    const returnData = getLocalStorageCache(LOCAL_STORE_KEY_CONFIGURATION + key, true, dataType !== 'string')

    return returnData
  }

  static removeConfiguration(key) {
    // window.localStorage.removeItem(key)
    removeLocalStorageCache(LOCAL_STORE_KEY_CONFIGURATION + key, true)
  }

  static getDelegationInfo() {
    return this.getConfiguration('delegationInfo')
  }
  static setDelegationInfo(delegation) {
    return this.setConfiguration('delegationInfo', delegation)
  }
  static clearDelegationInfo() {
    return this.removeConfiguration('delegationInfo')
  }
}
export default LocalStorageUtils
